import { IconButton } from "@chakra-ui/button"
import { Box } from "@chakra-ui/layout";
import { DeleteIcon } from "lib/icons/delete";
import { FC } from "react";
import { IconButtonProps } from "@chakra-ui/react";

export const IconButtonDelete: FC<Partial<IconButtonProps>> = (props) => (
  <Box>
    <IconButton variant="destructive" size="sm" aria-label="Delete asset" {...props}>
      <DeleteIcon boxSize="16px" />
    </IconButton>
  </Box>
);
